module.exports = __webpack_public_path__ + "media/images/pepsi-and-coke-1507e136a9f8d15bb9526f7c7e975706.png";